module.exports = __webpack_public_path__ + "img/1163624.7ee70f9f.svg";